<template>
  <div class="formularioSolicitudMoral" data-app>
    <div class="div-titulo-seccion"> 
      <div class="row row-cols-lg-12">
        <div class="col-lg-8 columna-titulo">
          <p class="titulo-seccion-t">{{this.NombreCompletoProspecto}}</p>
        </div>
        <div class="col-lg-4 columna-boton">
          <label
            class="label-guardar-progreso-t"
            @click.prevent="GuardarBorradorSolicitud()"
            v-if="seccionActual != 5 && soloLectura == false"
            >Guardar progreso</label
          >
        </div>
      </div>
    </div>
    <div class="container form-container">
      <stepper-movil
        :pasos="this.pasos"
        :pasoActual="this.seccionActual"
      ></stepper-movil>
      <stepper :pasos="this.pasos" :pasoActual="this.seccionActual"></stepper>
      <div ref="seccion-1" v-show="seccionActual == 1">
        <form
          class="requiere-validacion"
          novalidate
          ref="formularioUno"
          v-bind:class="{ 'was-validated': formularioValidado1 }"
        >
          <div class="row row-cols-lg-12 w-100 mt-3">
            <strong class="titulo-seccion">Datos generales</strong>
            <p class="parrafo-instrucciones mt-2">
              Ingresa correctamente tus datos en cada uno de los campos.
              Recuerda que puedes utilizar el ícono de ayuda
              <i class="fas fa-question-circle icono-ayuda fa-lg"></i> para
              conocer más detalles sobre su llenado
            </p>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6 campo-solicitud">
              <etiqueta-campo
                texto="¿Que servicio deseas?"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                :disabled="soloLectura"
                placeholder="Selecciona ¿Qué servicio deseas? *"
                :arreglo="this.catalogos.servicios"
                llave="value"
                valor="value"
                texto="text"
                :requerido="true"
                v-model="DatosSolicitudGeneral.servicio"
                invalidFeedback="Debes de seleccionar un servicio."
              ></DropDown>
            </div>
            <div class="col-lg-6 campo-solicitud">
              <etiqueta-campo
                texto="¿Que producto deseas?"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                :disabled="soloLectura"
                placeholder="Selecciona ¿Que producto deseas? *"
                :arreglo="this.catalogos.productos"
                llave="value"
                valor="value"
                texto="text"
                :requerido="true"
                v-model="DatosSolicitudGeneral.producto"
                invalidFeedback="Debes de seleccionar un producto."
              ></DropDown>
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6 campo-solicitud">
              <etiqueta-campo
                texto="Nombre de la empresa"
                :requerido="true"
              ></etiqueta-campo>
              <input
                placeholder="Nombre de la empresa*"
                type="text"
                class="form-control campo-basico"
                v-model="DatosPersonaMoral.nombreComercial"
                required
              />
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                Debes indicar el nombre comercial de la empresa.
              </div>
            </div>
            <div class="col-lg-6 campo-solicitud">
              <etiqueta-campo
                texto="Razón social"
                :requerido="true"
              ></etiqueta-campo>
              <input
                placeholder="Razón social*"
                type="text"
                class="form-control campo-basico"
                v-model="DatosPersonaMoral.razonSocial"
                required
              />
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                Debes indicar la razón social de la empresa.
              </div>
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6 campo-solicitud">
              <etiqueta-campo texto="RFC" :requerido="true"></etiqueta-campo>
              <input
                placeholder="RFC*"
                type="text"
                class="form-control campo-basico"
                v-model="DatosPersonaMoral.rfc"
                required
              />
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                Debes indicar el RFC de la empresa.
              </div>
            </div>
            <div class="col-lg-6 campo-solicitud">
              <etiqueta-campo
                texto="Lugar de constitución de la empresa"
                :requerido="true"
              ></etiqueta-campo>
              <input
                placeholder="Ej. Ciudad de México"
                :disabled="soloLectura"
                type="text"
                class="form-control campo-basico"
                v-model="DatosPersonaMoral.lugarConstitucion"
                required
              />
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                El lugar de constitución es requerido.
              </div>
            </div>
          </div>

          <div class="row row-cols-lg-12">
            <div class="col-md-6 col-lg-12 columna--campos">
              <etiqueta-campo
                texto="Regimen Fiscal"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                :disabled="this.soloLectura"
                placeholder="Regimen Fiscal"
                :arreglo="this.catalogos.regimenesFiscales"
                llave="regimenFiscalId"
                valor="regimenFiscalId"
                texto="nombreRegimen"
                v-model="DatosPersonaMoral.regimenFiscalId"
                :requerido="true"
              ></DropDown>
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                El regimen fiscal es requerido.
              </div>
            </div>
          </div>

          <div class="row row-cols-lg-12">
            <div class="col-lg-6" style="text-align: left">
              <etiqueta-campo
                texto="Fecha en que fue constituida la empresa"
                :requerido="true"
              ></etiqueta-campo>
              <input-fecha
                :deshabilitado="soloLectura"
                idioma="es-MX"
                v-model="DatosSolicitudGeneral.fechaNacimiento"
                :fechaMaxima="new Date().toISOString()"
              ></input-fecha>
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                La fecha en la que fue constituida la empresa es requerida.
              </div>
            </div>
            <div class="col-lg-6" style="text-align: left">
              <etiqueta-campo
                texto="Fecha en que la empresa inició operaciones"
                :requerido="true"
              ></etiqueta-campo>
              <input-fecha
                :deshabilitado="soloLectura"
                idioma="es-MX"
                v-model="DatosPersonaMoral.fechaInicioOperaciones"
                :fechaMaxima="new Date().toISOString()"
              ></input-fecha>
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                La fecha de inicio de operaciones es requerida.
              </div>
            </div>
          </div>
          <div class="row row-cols-lg-12" style="text-align: right">
            <small class="float-right texto-politicas"
              >*Por política de Hir Casa la empresa deberá tener como mínimo dos
              años de estar operando.</small
            >
          </div>
          <div class="row row-cols-lg-12 w-100 mt-3 mb-3">
            <strong class="titulo-seccion">Domicilio de la empresa</strong>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6 campo-solicitud">
              <etiqueta-campo texto="Calle" :requerido="true"></etiqueta-campo>
              <input
                placeholder="Calle*"
                :disabled="soloLectura"
                type="text"
                class="form-control campo-basico"
                v-model="DatosUbicacionGeneralOficina.calle"
                required
              />
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                La calle es requerida.
              </div>
            </div>
            <div class="col-lg-6 campo-solicitud">
              <etiqueta-campo texto="Número" :requerido="true"></etiqueta-campo>
              <input
                maxlength="20"
                placeholder="Número*"
                :disabled="soloLectura"
                type="text"
                min="0"
                class="form-control campo-basico"
                v-model="DatosUbicacionGeneralOficina.numero"
                required
              />
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                El número es requerido.
              </div>
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6 campo-solicitud">
              <etiqueta-campo
                texto="Código postal"
                :requerido="true"
              ></etiqueta-campo>
              <input
                placeholder="Código postal*"
                :disabled="soloLectura"
                type="number"
                onkeydown="return event.keyCode !== 69"
                onkeypress="return event.keyCode !== 43 && event.keyCode !== 45 && event.keyCode !== 46"
                min="0"
                class="form-control campo-basico"
                v-model="direccionAuxiliar.codigoPostal"
                required
                pattern="[0-9]{5}"
              />
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                El código postal es requerido.
              </div>
            </div>
            <div class="col-lg-6 campo-solicitud">
              <etiqueta-campo texto="Estado" :requerido="true"></etiqueta-campo>
              <input
                placeholder="Estado*"
                type="text"
                class="form-control campo-basico"
                v-model="direccionAuxiliar.estado"
                disabled
              />
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6 campo-solicitud">
              <etiqueta-campo
                texto="Delegación o municipio"
                :requerido="true"
              ></etiqueta-campo>
              <input
                placeholder="Delegación o municipio *"
                type="text"
                class="form-control campo-basico"
                v-model="direccionAuxiliar.ciudad"
                disabled
              />
            </div>
            <div
              class="col-lg-6 campo-solicitud"
              v-if="
                (direccionAuxiliar.codigoPostalValido == true &&
                  catalogos.colonias.length > 0) ||
                  direccionAuxiliar.coloniaExistente != null
              "
            >
              <etiqueta-campo
                texto="Colonia"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                :disabled="soloLectura"
                placeholder="Selecciona una colonia*"
                :arreglo="this.catalogos.colonias"
                llave="coloniaId"
                valor="coloniaId"
                texto="descripcion"
                v-model="DatosUbicacionOficina.coloniaId"
                :required="true"
              ></DropDown>
            </div>
            <div class="col-lg-6 campo-solicitud" v-else>
              <etiqueta-campo
                texto="Colonia"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                disabled
                placeholder="Selecciona una colonia*"
                llave="coloniaId"
                valor="coloniaId"
                texto="descripcion"
                v-model="DatosUbicacionOficina.coloniaId"
                :required="true"
              ></DropDown>
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6 campo-solicitud">
              <etiqueta-campo texto="Teléfono (10 dígitos)"></etiqueta-campo>
              <input
                placeholder="Teléfono (10 dígitos)*"
                :disabled="soloLectura"
                type="text"
                class="form-control campo-basico"
                v-model="PuntoContactoGeneral.telefonoFijoOficina.valor"
              />
            </div>
            <div class="col-lg-6 campo-solicitud">
              <etiqueta-campo
                texto="Correo electrónico"
                :requerido="true"
              ></etiqueta-campo>
              <input
                placeholder="Correo electrónico*"
                disabled
                type="text"
                class="form-control campo-basico campo-minuscula"
                v-model="PuntoContactoGeneral.correoMoral.valor"
              />
            </div>
          </div>
          <button
            ref="submitUno"
            @click.prevent="ValidaFormSiguiente"
            class="btn"
            hidden
            type="submit"
          ></button>
        </form>
      </div>
      <div ref="seccion-2" v-show="seccionActual == 2">
        <form
          class="requiere-validacion"
          novalidate
          ref="formularioDos"
          v-bind:class="{ 'was-validated': formularioValidado2 }"
        >
          <div class="row row-cols-lg-12 w-100 mt-3">
            <strong class="titulo-seccion">Información adicional</strong>
            <p class="parrafo-instrucciones mt-2">
              Ingresa correctamente la información adicional, incluye el giro,
              filial, socios, accionistas y representante legal que
              correspondan.
            </p>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6 campo-solicitud">
              <etiqueta-campo
                texto="Giro de la empresa"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                v-if="(this.catalogos.giros || []).length"
                :disabled="this.soloLectura"
                placeholder="Giro*"
                :arreglo="this.catalogos.giros"
                llave="giroId"
                valor="giroId"
                texto="giro"
                v-model="DatosPersonaMoral.giroId"
              ></DropDown>
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                El giro de la empresa es requerido.
              </div>
            </div>
            <div class="col-lg-6 campo-solicitud">
              <etiqueta-campo
                texto="Actividad principal"
                :requerido="true"
              ></etiqueta-campo>
              <input
                placeholder="Actividad principal*"
                :disabled="soloLectura"
                type="text"
                class="form-control campo-basico"
                v-model="DatosPersonaMoral.actividadPrincipal"
                required
              />
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                La actividad principal de la empresa es requerida.
              </div>
            </div>
          </div>
          <div class="row row-cols-lg-12 w-100 mt-5">
            <strong class="titulo-seccion">Representante legal</strong>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6" v-if="existeProspectoRepresentanteLegal">
              <etiqueta-campo
                texto="Nombre(s)"
                :requerido="true"
              ></etiqueta-campo>
              <input
                placeholder="Nombre(s)*"
                :disabled="soloLectura"
                type="text"
                class="form-control campo-basico"
                v-model="representanteLegal.nombre"
                required
              />
            </div>
            <div class="col-lg-6 campo-solicitud" v-else>
              <etiqueta-campo
                texto="Nombre(s)"
                :requerido="true"
              ></etiqueta-campo>
              <input
                placeholder="Nombre(s)*"
                :disabled="soloLectura"
                type="text"
                class="form-control campo-basico"
                v-model="representanteLegal.nombre"
                required
                onpaste="return false;"
                ondrop="return false;"
                autocomplete="off"
              />
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                El nombre del representante legal es requerido.
              </div>
            </div>
            <div
              class="col-lg-6 campo-solicitud"
              v-if="existeProspectoRepresentanteLegal"
            >
              <etiqueta-campo
                texto="Apellido paterno"
                :requerido="true"
              ></etiqueta-campo>
              <input
                placeholder="Apellido paterno*"
                :disabled="soloLectura"
                type="text"
                class="form-control campo-basico"
                v-model="representanteLegal.apellidoPaterno"
                required
              />
            </div>
            <div class="col-lg-6 campo-solicitud" v-else>
              <etiqueta-campo
                texto="Apellido paterno"
                :requerido="true"
              ></etiqueta-campo>
              <input
                placeholder="Apellido paterno*"
                :disabled="soloLectura"
                type="text"
                class="form-control campo-basico"
                v-model="representanteLegal.apellidoPaterno"
                required
                onpaste="return false;"
                ondrop="return false;"
                autocomplete="off"
              />
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                El apellido paterno del representante legal es requerido.
              </div>
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div
              class="col-lg-6 campo-solicitud"
              v-if="existeProspectoRepresentanteLegal"
            >
              <etiqueta-campo
                texto="Apellido materno"
                :requerido="true"
              ></etiqueta-campo>
              <input
                placeholder="Apellido materno"
                :disabled="soloLectura"
                type="text"
                class="form-control campo-basico"
                v-model="representanteLegal.apellidoMaterno"
                required
              />
            </div>
            <div class="col-lg-6 campo-solicitud" v-else>
              <etiqueta-campo
                texto="Apellido materno"
                :requerido="true"
              ></etiqueta-campo>
              <input
                placeholder="Apellido materno"
                :disabled="soloLectura"
                type="text"
                class="form-control campo-basico"
                v-model="representanteLegal.apellidoMaterno"
                required
                onpaste="return false;"
                ondrop="return false;"
                autocomplete="off"
              />
            </div>
            <div
              class="col-lg-6 campo-solicitud"
              v-if="existeProspectoRepresentanteLegal"
            >
              <etiqueta-campo
                texto="Teléfono fijo (10 dígitos)"
                :requerido="true"
              ></etiqueta-campo>
              <input
                placeholder="Teléfono fijo (10 dígitos)"
                disabled
                type="number"
                onkeydown="return event.keyCode !== 69"
                onkeypress="return event.keyCode !== 43 && event.keyCode !== 45 && event.keyCode !== 46"
                class="form-control campo-basico"
                v-model="PuntoContactoGeneral.telefonoFijo.valor"
                required
              />
            </div>
            <div class="col-lg-6 campo-solicitud" v-else>
              <etiqueta-campo
                texto="Teléfono fijo (10 dígitos)"
                :requerido="true"
              ></etiqueta-campo>
              <input
                placeholder="Teléfono fijo (10 dígitos)"
                :disabled="soloLectura"
                type="number"
                onkeydown="return event.keyCode !== 69"
                onkeypress="return event.keyCode !== 43 && event.keyCode !== 45 && event.keyCode !== 46"
                class="form-control campo-basico"
                v-model="PuntoContactoGeneral.telefonoFijo.valor"
                required
                onpaste="return false;"
                ondrop="return false;"
                autocomplete="off"
              />
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div
              class="col-lg-6 campo-solicitud"
              v-if="existeProspectoRepresentanteLegal"
            >
              <etiqueta-campo
                texto="Telefono móvil (10 dígitos)"
                :requerido="true"
              ></etiqueta-campo>
              <input
                placeholder="Teléfono móvil (10 dígitos)*"
                :disabled="soloLectura"
                type="number"
                onkeydown="return event.keyCode !== 69"
                onkeypress="return event.keyCode !== 43 && event.keyCode !== 45 && event.keyCode !== 46"
                class="form-control campo-basico"
                v-model="PuntoContactoGeneral.telefonoMovil.valor"
                required
              />
            </div>
            <div class="col-lg-6 campo-solicitud" v-else>
              <etiqueta-campo
                texto="Telefono móvil (10 dígitos)"
                :requerido="true"
              ></etiqueta-campo>
              <input
                placeholder="Teléfono móvil (10 dígitos)*"
                :disabled="soloLectura"
                type="number"
                onkeydown="return event.keyCode !== 69"
                onkeypress="return event.keyCode !== 43 && event.keyCode !== 45 && event.keyCode !== 46"
                class="form-control campo-basico"
                v-model="PuntoContactoGeneral.telefonoMovil.valor"
                required
                onpaste="return false;"
                ondrop="return false;"
                autocomplete="off"
              />
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                El teléfono móvil del representante legal es requerido.
              </div>
            </div>
            <div
              class="col-lg-6 campo-solicitud"
              v-if="existeProspectoRepresentanteLegal"
            >
              <etiqueta-campo
                texto="Correo electrónico"
                :requerido="true"
              ></etiqueta-campo>
              <input
                placeholder="Ej. juanperez@empresa.com"
                disabled
                type="text"
                class="form-control campo-basico campo-minuscula"
                v-model="PuntoContactoGeneral.correoRepresentante.valor"
                required
              />
            </div>
            <div class="col-lg-6 campo-solicitud" v-else>
              <etiqueta-campo
                texto="Correo electrónico"
                :requerido="true"
              ></etiqueta-campo>
              <input
                placeholder="Correo electrónico*"
                :disabled="soloLectura"
                type="text"
                class="form-control campo-basico campo-minuscula"
                v-model="PuntoContactoGeneral.correoRepresentante.valor"
                required
                onpaste="return false;"
                ondrop="return false;"
                autocomplete="off"
              />
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                El teléfono correo electrónico del representante legal es
                requerido.
              </div>
            </div>
          </div>
          <div class="row row-cols-lg-12 w-100 mt-5">
            <strong class="titulo-seccion">Socios</strong>
            <p class="parrafo-instrucciones mt-2">
              Es importante colocar la información completa del socio
              mayoritario (quien tiene el control de más del 50% de la tenencia
              accionaria)
            </p>
          </div>
          <div
            v-for="(formSocio, index) in FormSocios"
            v-bind:key="'socio' + FormSocios.indexOf(formSocio)"
            class="mb-3"
          >
            <div class="row row-cols-lg-12">
              <div class="col-lg-6 campo-solicitud">
                <etiqueta-campo
                  texto="Nombre(s)"
                  :requerido="true"
                ></etiqueta-campo>
                <input
                  required
                  :disabled="soloLectura"
                  type="text"
                  placeholder="Nombres(s)*"
                  class="form-control campo-basico campo-item-anadido"
                  v-model="formSocio.nombre"
                />
              </div>
              <div class="col-lg-6 campo-solicitud">
                <etiqueta-campo
                  texto="Apellido paterno"
                  :requerido="true"
                ></etiqueta-campo>
                <input
                  required
                  :disabled="soloLectura"
                  type="text"
                  placeholder="Apellido paterno*"
                  v-model="formSocio.apellidoPaterno"
                  class="form-control campo-basico campo-item-anadido"
                />
              </div>
            </div>
            <div class="row row-cols-lg-12 row-ap-materno-socio">
              <div class="col-lg-6 campo-solicitud">
                <etiqueta-campo texto="Apellido materno"></etiqueta-campo>
                <input
                  :disabled="soloLectura"
                  type="text"
                  placeholder="Apellido materno"
                  v-model="formSocio.apellidoMaterno"
                  class="form-control campo-basico campo-item-anadido"
                />
              </div>
              <div class="col-lg-6 campo-solicitud">
                <etiqueta-campo
                  texto="Cargo"
                  :requerido="true"
                ></etiqueta-campo>
                <input
                  required
                  :disabled="soloLectura"
                  placeholder="Cargo*"
                  type="text"
                  class="form-control campo-basico campo-item-anadido"
                  v-model="formSocio.cargo"
                />
              </div>
            </div>
            <div class="row row-cols-lg-12 row-ap-materno-socio">
              <div class="col-lg-6 campo-solicitud">
                <div class="input-group">
                  <etiqueta-campo
                    texto="Porcentaje de participación"
                    :requerido="true"
                  ></etiqueta-campo>
                  <input
                    required
                    :disabled="soloLectura"
                    @keyup="LimitarPorcentajeSocios(index)"
                    type="number"
                    onkeydown="return event.keyCode !== 69"
                    onkeypress="return event.keyCode !== 43 && event.keyCode !== 45 && event.keyCode !== 46"
                    min="0"
                    class="form-control campo-basico campo-item-anadido"
                    v-model="formSocio.participacion"
                    placeholder="Ej. 15"
                  />
                  <div class="input-group-prepend">
                    <span
                      class="input-group-text"
                      style="border-radius: 0px; border: 1px solid"
                      >%</span
                    >
                  </div>
                </div>
              </div>
              <div class="col-lg-6"></div>
            </div>
            <div
              class="col-lg-12 col-sm-12"
              style="text-align: end"
              v-show="soloLectura == false"
            >
              <strong
                v-if="
                  FormSocios.length > 1 &&
                    CamposSociosActualesVacios(index) == false
                "
                class="etiqueta-nuevo-documento"
                @click.prevent="EliminarSocio(index)"
                >Eliminar socio</strong
              >
            </div>
          </div>
          <div
            v-show="soloLectura == false"
            class="row row-cols-lg-12 mb-4"
            style="justify-content: flex-end"
          >
            <strong
              class="etiqueta-nuevo-documento w-auto"
              @click.prevent="AgregarSocio()"
              >Agregar otro socio</strong
            >
          </div>
          <div class="row row-cols-lg-12 w-100 mt-5">
            <strong class="titulo-seccion">Principal accionista</strong>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6 campo-solicitud">
              <etiqueta-campo
                texto="Nombre(s)"
                :requerido="true"
              ></etiqueta-campo>
              <input
                placeholder="Nombre(s)*"
                :disabled="soloLectura"
                type="text"
                class="form-control campo-basico"
                v-model="accionista.nombre"
                required
              />
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                El nombre del principal accionista es requerido.
              </div>
            </div>
            <div class="col-lg-6 campo-solicitud">
              <etiqueta-campo
                texto="Apellido paterno"
                :requerido="true"
              ></etiqueta-campo>
              <input
                placeholder="Apellido paterno*"
                :disabled="soloLectura"
                type="text"
                class="form-control campo-basico"
                v-model="accionista.apellidoPaterno"
                required
              />
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                El apellido paterno del accionista es requerido.
              </div>
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6 campo-solicitud">
              <etiqueta-campo texto="Apellido materno"></etiqueta-campo>
              <input
                placeholder="Apellido materno*"
                :disabled="soloLectura"
                type="text"
                class="form-control campo-basico"
                v-model="accionista.apellidoMaterno"
              />
            </div>
            <div class="col-lg-6 campo-solicitud"></div>
          </div>
          <div class="row row-cols-lg-12 w-100 mt-3">
            <strong class="titulo-seccion"
              >Filiales y/o grupos a los que pertenece la empresa</strong
            >
          </div>
          <div
            v-for="(formFilial, index) in FormFiliales"
            v-bind:key="'filial' + FormFiliales.indexOf(index)"
            class="mb-3 mt-3"
          >
            <div class="row row-cols-lg-12">
              <div class="col-lg-6 campo-solicitud">
                <etiqueta-campo
                  texto="Razón social o nombre comercial"
                ></etiqueta-campo>
                <input
                  :disabled="soloLectura"
                  type="text"
                  placeholder="Ej. Abarrotes Perez"
                  class="form-control campo-basico campo-item-anadido"
                  v-model="formFilial.nombre"
                />
              </div>
              <div class="col-lg-6 campo-solicitud">
                <etiqueta-campo texto="Ubicación"></etiqueta-campo>
                <input
                  :disabled="soloLectura"
                  type="text"
                  placeholder="Ej. Jardines del sur 45, Coyoacán, Ciudad de México."
                  class="form-control campo-basico campo-item-anadido"
                  v-model="formFilial.ubicacion"
                />
              </div>
            </div>

            <div
              class="col-lg-12 col-sm-12"
              style="text-align: end"
              v-show="soloLectura == false"
            >
              <strong
                v-if="
                  FormFiliales.length > 1 &&
                    CamposFilialesActualesVacios(index) == false
                "
                class="etiqueta-nuevo-documento"
                @click.prevent="EliminarFilial(index)"
                >Eliminar filial</strong
              >
            </div>
          </div>
          <div
            v-show="soloLectura == false"
            class="row row-cols-lg-12 mb-4"
            style="justify-content: flex-end"
          >
            <strong
              class="etiqueta-nuevo-documento"
              @click.prevent="AgregarFilial()"
              >Agregar filial/grupo</strong
            >
          </div>
          <button
            ref="submitDos"
            @click.prevent="ValidaFormSiguiente"
            hidden
            type="submit"
          >
            Submit form
          </button>
        </form>
      </div>
      <div ref="seccion-3" v-show="seccionActual == 3">
        <form
          class="requiere-validacion"
          novalidate
          ref="formularioUltimo"
          v-bind:class="{ 'was-validated': formularioUltimoValidado }"
        >
          <div class="row row-cols-lg-12 w-100 mt-3">
            <strong class="titulo-seccion">Envío de estado de cuenta</strong>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-12 campo-solicitud">
              <etiqueta-campo
                texto="¿Por qué medio deseas recibir tu estado de cuenta?"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                :requerido="true"
                :disabled="soloLectura"
                placeholder="Elige una vía*"
                :arreglo="this.catalogos.tiposEnvio"
                llave="value"
                valor="value"
                texto="text"
                v-model="DatosSolicitudGeneral.envioEstadoCuenta"
              ></DropDown>
            </div>
          </div>
          <div class="row row-cols-lg-12" style="text-align: justify">
            <div class="pl-2">
              <div class="form-check mt-4">
                <input
                  :disabled="this.soloLectura"
                  class="form-check-input"
                  style="font-size: 14px; cursor: pointer"
                  type="checkbox"
                  v-model="DatosSolicitudGeneral.aceptaInformacionTerceros"
                />
                <label
                  class="form-check-label font-weight-bold terminos-solicitud"
                  >Acepto que HIR Casa ceda o transmita información a terceros,
                  con fines mercadotécnicos o publicitarios, la información
                  proporcionada con motivo del presente Contrato de
                  Adhesión.</label
                >
              </div>
              <div class="form-check mt-4">
                <input
                  :disabled="this.soloLectura"
                  class="form-check-input"
                  style="font-size: 14px; cursor: pointer"
                  type="checkbox"
                  v-model="DatosSolicitudGeneral.aceptaInformacionPublicitaria"
                />
                <label
                  class="form-check-label font-weight-bold terminos-solicitud"
                  >Acepto que HIR Casa me envíe publicidad sobre bienes y
                  servicios.</label
                >
              </div>
            </div>
          </div>
          <button
            ref="submitUltimo"
            @click.prevent="GuardarSolicitudCompletamente"
            class="btn btn-primary"
            hidden
            type="submit"
          ></button>
        </form>
      </div>
      <div
        class="row row-cols-lg-12 mt-5 mb-2 columna-botones"
        style="justify-content: flex-end"
      >
        <button
          type="button"
          class="boton-transparente boton-seccion-anterior"
          @click.prevent="AnteriorSeccion()"
          v-if="seccionActual != 1"
        >
          Anterior
        </button>
        <button
          type="button"
          class="boton-primario boton-siguiente-seccion"
          @click.prevent="SeccionSiguiente()"
          v-if="seccionActual != 3"
        >
          Siguiente
        </button>
        <div
          style="display: contents"
          v-if="
            (solicitudExistenteId == 0 || solicitudExistenteId == null) &&
              seccionActual == 3
          "
        >
          <button
            v-if="tipoUsuario == 0 || tipoUsuario == 2 || tipoUsuario == 5"
            disabled
            class="boton-primario boton-siguiente-seccion"
            style="opacity: 0.5; cursor: default"
          >
            Finalizar
          </button>
          <button
            v-else
            type="button"
            :disabled="this.soloLectura"
            class="boton-primario boton-siguiente-seccion"
            @click.prevent="ActivarEnvioFormulario"
          >
            <span v-if="!confirmandoDatos">
              Finalizar
            </span>
            <v-progress-circular
              v-else
              indeterminate
              size="30"
              color="primary"
            ></v-progress-circular>
          </button>
        </div>
        <div
          style="display: contents"
          v-else-if="
            (solicitudExistenteId != 0 || solicitudExistenteId != null) &&
              seccionActual == 3
          "
        >
          <button
            v-if="tipoUsuario == 0 || tipoUsuario == 2 || tipoUsuario == 5"
            disabled
            class="boton-primario boton-siguiente-seccion"
            style="opacity: 0.5; cursor: default"
          >
            Actualizar
          </button>
          <button
            v-else
            type="button"
            class="boton-primario boton-siguiente-seccion"
            @click.prevent="ActivarEnvioFormulario"
          >
            <span v-if="!confirmandoDatos">
              Actualizar
            </span>
            <v-progress-circular
              v-else
              indeterminate
              size="30"
              color="primary"
            ></v-progress-circular>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="js">

//Componentes
import DropDown from "../components/DropDown.vue";
import Stepper from "../components/Stepper.vue";
import StepperMovil from "../components/StepperMovil.vue";
import InputFecha from "../components/InputFecha.vue"

//Plugins y mixins.
import axios from "axios";
import servicios from '../../../servicios/service.js';
import mixinSolicitudInscripcion from "../Mixins/MixinSolicitudInscripcion";

//rutasApi
const rutaCodigosPostales = "/api/Master/SolicitudInscripcion/ValidarCodigoPostal";
const rutaColonias = "/api/Master/SolicitudInscripcion/ObtenerColonias";
const rutaCiudad = "/api/Master/SolicitudInscripcion/ObtenerCiudad";
const rutaEstado = "/api/Master/SolicitudInscripcion/ObtenerEstado";
const rutaCargarDatosProspecto = "/api/Master/Prospecto/ObtenerProspecto";
const rutaGuardarSolicitud = "/api/Master/SolicitudInscripcion/GuardarSolicitudInscripcion";
const rutaGuardarSolicitudPm = "/api/Master/SolicitudInscripcion/GuardarSolicitudInscripcionPersonaMoral";
const rutaGuardarFilial = "/api/Master/SolicitudInscripcion/GuardarFilial";
const rutaGuardarSocio = "/api/Master/SolicitudInscripcion/GuardarSocio";
const rutaGuardarUbicacion = "/api/Master/SolicitudInscripcion/GuardarUbicacionGeneral";
const rutaGuardarUbicacionLocal = "/api/Master/SolicitudInscripcion/GuardarUbicacionLocal";
const rutaConsultarSolicitudPersonaMoral =
  "/api/Master/SolicitudInscripcion/ObtenerSolicitudInscripcionPersonaMoral";
const rutaConsultarPuntosContacto = "/api/Master/SolicitudInscripcion/ObtenerPuntosContacto";
const rutaConsultarUbicaciones = "/api/Master/SolicitudInscripcion/ObtenerUbicaciones";
const rutaConsultarUbicacionLocal =   "/api/Master/SolicitudInscripcion/ObtenerUbicacionLocal";
const rutaCodigoPostalExistente = "/api/Master/SolicitudInscripcion/ObtenerCodigoPostal";
const rutaConsultarSocios = "/api/Master/SolicitudInscripcion/ObtenerSocios";
const rutaEliminarSocio = "/api/Master/SolicitudInscripcion/EliminarSocio";
const rutaConsultarFiliales = "/api/Master/SolicitudInscripcion/ObtenerFiliales";
const rutaEliminarFilial = "/api/Master/SolicitudInscripcion/EliminarFilial";
const rutaCrearProspectoRL = "/api/Master/Prospecto/CrearProspectoRepresentanteLegal";
const rutaExisteProspectoRepresentante = "/api/Master/Prospecto/ConsultaProspectoRepresentanteLegal";

const prospecto = {
  params: { prospectoId: null },
};

export default {
  name: "FormularioSolicitudInscripcionMoral",
  components: {
      DropDown,
      Stepper,
      StepperMovil,
      InputFecha
  },
  mixins: [mixinSolicitudInscripcion],
  data() {
    return {
        pasos: ['Datos generales', 'Información adicional', 'Estado de cuenta'],
        seccionActual: 1,
        formularioValidado1:false,
        formularioValidado2:false,
        formularioUltimoValidado:false,
        solicitudExistenteId: 0,
        existeProspectoRepresentanteLegal: false,
        NombreCompletoProspecto: "",
        ProspectoId: null,
        catalogos: {
            productos: [],
            servicios: [],
            colonias: [],
            tiposEnvio: [],
            giros: [],
            puestos: [],
            regimenesFiscales: []
        },
        accionista: {
            nombre:"",
            apellidoPaterno: "",
            apellidoMaterno: ""
        },
        representanteLegal: {
            nombre:"",
            apellidoPaterno: "",
            apellidoMaterno: ""
        },
        direccionAuxiliar: {
            estado:"",
            ciudad:"",
            codigoPostal: null,
            codigoPostalValido: false,
            coloniaExistente: null
        },
        DatosSolicitudGeneral: {
            prospectoId:null,
            producto: null,
            servicio: null,
            fechaRegistroSolicitud:null,
            fechaNacimiento: null,
            envioEstadoCuenta:null,
            envioEstadoCuentaOriginal:null,
            enCasoAutorizacion : null,
            requiereFactura: false,
            aceptaInformacionTerceros: null,
            aceptaInformacionPublicitaria: null,
            solicitudCompletada:null
        },
        DatosPersonaMoral: {
            solicitudId: null,
            razonSocial: null,
            nombreComercial: null,
            rfc: null,
            lugarConstitucion:"",
            fechaInicioOperaciones: null,
            principalAccionista: "",
            representanteLegal: "",
            giroId: null,
            giro: null,
            regimenFiscal: null,
            puestoId: null,
            puesto: null,
            actividadPrincipal:"",
            regimenFiscalId: null,
        },
        PuntoContactoGeneral:{
          correoMoral: {
            puntoContactoId: 0,
            valor: null
          },
          correoRepresentante: {
            puntoContactoId: 0,
            valor: null
          },
          telefonoMovil:{
            puntoContactoId: 0,
            valor: null
          },
          telefonoFijo:{
            puntoContactoId: 0,
            valor: null
          },
          telefonoFijoOficina: {
            puntoContactoId: 0,
            valor: null
          },
        },
        DatosUbicacionGeneralOficina: {
            ubicacionId: 0,
            prospectoId: null,
            tipoUbicacion:1,
            calle: null,
            numero: null
        },
        DatosUbicacionOficina: {
          ubicacionId:null,
          coloniaId: null,
          coloniaIdOficinaOriginal: null,
        },
        FormFiliales: [
          {
            filialId: 0,
            prospectoId: 0,
            nombre: "",
            ubicacion: ""
          }
        ],
        FormSocios: [
          {
            socioId:0,
            prospectoId: 0,
            nombre: "",
            apellidoPaterno: "",
            apellidoMaterno: "",
            cargo: "",
            participacion: null
          }
        ],
        tipoUsuario: null,
        soloLectura: false,
        etapaProspecto: null,
        confirmandoDatos: false

    };
  },
  computed: {
    camposVaciosSocioForm: function() {
      let llaves = Object.keys(this.FormSocios[this.FormSocios.length -1]);
      let vacios = 0;
      llaves.forEach(llave => {
        if(llave != "apellidoMaterno" && llave != "socioId" && llave != "prospectoId"){
          if(this.FormSocios[this.FormSocios.length -1][llave] == "" || this.FormSocios[this.FormSocios.length -1][llave] == null){
            vacios++;
          }
        }
      });
      return vacios > 0 ? true : false;
    },
    camposVaciosFilialForm: function() {
      let llaves = Object.keys(this.FormFiliales[this.FormFiliales.length -1]);
      let vacios = 0;
      llaves.forEach(llave => {
        if(llave != "filialId" && llave != "prospectoId"){
          if(this.FormFiliales[this.FormFiliales.length -1][llave] == "" || this.FormFiliales[this.FormFiliales.length -1][llave] == null){
            vacios++;
          }
        }
      });
      return vacios > 0 ? true : false;
    },
  },
  async mounted() {
    this.ProspectoId = this.$store.getters.prospectoId;
    prospecto.params.prospectoId = this.ProspectoId;
    this.solicitudExistenteId = this.$store.getters.solicitudMoralId;
    // await this.CargarDatosProspectoMoral(this.ProspectoId);
    // await this.ConsultarProspectoRepresentanteLegal();
    this.DatosSolicitudGeneral.prospectoId = parseInt(this.ProspectoId);
    this.DatosUbicacionGeneralOficina.prospectoId = parseInt(this.ProspectoId);
    await this.CargarProductos(false);
    await this.CargarServicios(false);
    await this.CargarTiposEnvioEC(false);
    await this.CargarPuestos(false);
    await this.CargarGiros(false);
    await this.CargarRegimenesFiscales(false, true);

    await this.CargarDatosProspectoMoral(this.ProspectoId);
    await this.ConsultarProspectoRepresentanteLegal();

    this.NombreCompletoProspecto = "SOLICITUD DE INSCRIPCIÓN PERSONA MORAL: " + this.DatosPersonaMoral.nombreComercial + " " + this.DatosPersonaMoral.razonSocial;

     if(this.solicitudExistenteId != 0) {
      await this.ConsultarSolicitudGeneral();
      await this.ConsultarSolicitudPersonaMoral();
      await this.ConsultarPuntosContactoMoral();
      await this.ConsultarUbicaciones();
      await this.ConsultarFiliales();
      await this.ConsultarSocios();
    }
    this.tipoUsuario = this.$store.getters.tipoUsuario;
    
    this.VerificarSoloLectura();

    if(this.etapaProspecto > 4) this.soloLectura = true;
    if(this.etapaProspecto > 4)
    {
     this.seccionActual = 1;
    }


  if (this.tipoUsuario != 3) {
              this.seccionActual = 1;
            }

  },
  watch : {
    'PuntoContactoGeneral.telefonoFijo.valor' : function() {
      this.PuntoContactoGeneral.telefonoFijo.valor = servicios.LimitarTelefonoLocal(this.PuntoContactoGeneral.telefonoFijo.valor);
    },
    'PuntoContactoGeneral.telefonoMovil.valor' : function() {
      this.PuntoContactoGeneral.telefonoMovil.valor = servicios.LimitarTelefonoLocal(this.PuntoContactoGeneral.telefonoMovil.valor);
    },
    'PuntoContactoGeneral.telefonoFijoOficina.valor' : function() {
      this.PuntoContactoGeneral.telefonoFijoOficina.valor = servicios.LimitarTelefonoLocal(this.PuntoContactoGeneral.telefonoFijoOficina.valor);
    },
    'direccionAuxiliar.codigoPostal' : function() {
      if (this.direccionAuxiliar.codigoPostal == "") {
          this.catalogos.colonias = [];
          this.direccionAuxiliar.ciudad = "NO DETECTADO";
          this.direccionAuxiliar.estado = "NO DETECTADO";
          this.direccionAuxiliar.codigoPostalValido = false;
          this.DatosUbicacionOficina.coloniaId = null;
      }
      if(this.direccionAuxiliar.codigoPostal.length < 5) {
          this.catalogos.colonias = [];
          this.direccionAuxiliar.ciudad = "NO DETECTADO";
          this.direccionAuxiliar.estado = "NO DETECTADO";
          this.direccionAuxiliar.codigoPostalValido = false;
          this.DatosUbicacionOficina.coloniaId = null;
      }
      if(this.direccionAuxiliar.codigoPostal.length > 5) this.direccionAuxiliar.codigoPostal = this.direccionAuxiliar.codigoPostal.toString().substring(0,5);
      if(this.direccionAuxiliar.codigoPostal.length == 5 ) {
          if(this.direccionAuxiliar.codigoPostal == "00000"){
            this.catalogos.colonias = [];
            this.direccionAuxiliar.ciudad = "NO DETECTADO";
            this.direccionAuxiliar.estado = "NO DETECTADO";
            this.direccionAuxiliar.codigoPostalValido = false;
            this.DatosUbicacionOficina.coloniaId = null;
          } else {
            this.ConsultarCodigoPostal(this.direccionAuxiliar.codigoPostal);
          }
      } else {
        this.direccionAuxiliar.codigoPostalValido = false;
          this.catalogos.colonias = [];
          this.direccionAuxiliar.ciudad = "NO DETECTADO";
          this.direccionAuxiliar.estado = "NO DETECTADO";
          this.direccionAuxiliar.codigoPostalValido = false;
          this.DatosUbicacionOficina.coloniaId = null;
      }
    },
    'DatosSocio.participacion' : function () {
      this.DatosSocio.participacion = servicios.EvitarNegativos(this.DatosSocio.participacion);
      if(parseInt(this.DatosSocio.participacion) > 100) {
        this.DatosSocio.participacion = 100;
      }
    }
  },
  methods: {
    RfcPersonaMoralEsValido(){
      let rfcValido = false;
      var regExRfcMoral = /[a-zA-Z]{3,3}[0-9]{2}[0-1][0-9][0-3][0-9][a-zA-Z,0-9][a-zA-Z,0-9][0-9aA]$/;
      var rfcValidadoEstructura = regExRfcMoral.test(this.DatosPersonaMoral.rfc);
      if(rfcValidadoEstructura){
        var arregloRfc = this.DatosPersonaMoral.rfc.split("");
        var year = arregloRfc[3] + arregloRfc[4];
        var mes = arregloRfc[5] + arregloRfc[6];
        var dia = arregloRfc[7] + arregloRfc[8];

        var fechaConstitucion = this.DatosSolicitudGeneral.fechaNacimiento .replaceAll("-","");
        var yearFechaNacimiento = fechaConstitucion.substring(2,4);
        var mesFechaNacimiento = fechaConstitucion.substring(4,6);
        var diaFechaNacimiento = fechaConstitucion.substring(6,8);

        if(year == yearFechaNacimiento && mes == mesFechaNacimiento && dia == diaFechaNacimiento) return true;
      }
      return rfcValido;
    },
    async ConsultarProspectoRepresentanteLegal() {
      const prospectoMoral = {
          params: {
            prospectoId: this.ProspectoId,
          },
        };
      await axios
        .get(rutaExisteProspectoRepresentante, prospectoMoral)
        .then((resp) => {
          if (resp.data.estado === 0) {
            if(resp.data.data == true) {
              this.existeProspectoRepresentanteLegal = true;
            }
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, true);
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
     GuardarBorradorSolicitud() {
      if(this.seccionActual == 1) {
        let camposLlenos = 0;
        var llaves = Object.keys(this.DatosSolicitudGeneral);
        llaves.forEach((llave) => {
          if(typeof this.DatosSolicitudGeneral[llave] != "boolean")
            if((llave != "solicitudId" && llave != "prospectoId") && this.DatosSolicitudGeneral[llave] != null)
              camposLlenos ++;
        });
        if(camposLlenos >= 1) {
          this.AjustarTiposDeDatos();
          this.GuardarSolicitud(this.DatosSolicitudGeneral,true);
        } else {
          this.AlertaEmbajadores("Para guardar tu progreso debes llenar al menos un campo.", true);
        }
      } else {
        this.AjustarTiposDeDatos();
        this.GuardarSolicitud(this.DatosSolicitudGeneral,true);
      }
    },
    GuardarSolicitudCompletamente(){
      let formularioValidado = false;
      this.formularioUltimoValidado = true;
      formularioValidado = this.$refs.formularioUltimo.checkValidity();

      if(formularioValidado) {
        this.DatosSolicitudGeneral.solicitudCompletada = true;
        //Se guarda toda la solicitud
        this.AjustarTiposDeDatos();
        this.GuardarSolicitud(this.DatosSolicitudGeneral,false);
      }
    },
    AnteriorSeccion(){
      if(this.seccionActual != 1) {
        this.seccionActual--;
      }
    },
    SeccionSiguiente(){
    switch (this.seccionActual) {
      case 1:
        this.$refs.submitUno.click();
        window.scrollTo(0,0);
        break;
      case 2:
        this.$refs.submitDos.click();
        break;
      case 3:
        this.$refs.submitTres.click();
        break;
      case 4:
        //Validaciones de beneficiarios
        if(this.beneficiarios.length > 0) {
          if(this.sumaBeneficiarios == 100) {
            this.seccionActual++;
          } else{
            this.AlertaEmbajadores("Los beneficiarios deben sumar un total de 100%.", true);
          }
        } else {
          this.AlertaEmbajadores("Debe ingresar al menos un beneficiario.", true);
        }
        break;
      }
    },
    ValidaFormSiguiente(){
    let formularioValidado = false;
      switch (this.seccionActual) {
        case 1:
          this.formularioValidado1 = true;
          formularioValidado = this.$refs.formularioUno.checkValidity();
          break;
        case 2:
          this.formularioValidado2 = true;
          formularioValidado = this.$refs.formularioDos.checkValidity();
          break;
      }

      if(formularioValidado) {
        if(this.seccionActual == 1) {
          if(this.DatosSolicitudGeneral.fechaNacimiento == null) {
          this.AlertaEmbajadores("Por favor indica la fecha de constitución de la empresa.", true);
          return;
        } else if (!this.RfcPersonaMoralEsValido()) {
          this.AlertaEmbajadores("Por favor verifica que el RFC tenga el formato correcto y las fechas coincidan con la fecha de constitución de tu empresa.", true);
          return;
        } else if (this.DatosPersonaMoral.fechaInicioOperaciones == null) {
          this.AlertaEmbajadores("Por favor indica la fecha en la que la empresa inició operaciones.", true);
          return;
        } else if(this.direccionAuxiliar.codigoPostalValido == false) {
            this.AlertaEmbajadores("Por favor verifica que los datos del domicilio de la empresa sean correctos o estén completos.", true);
            return;
          } else {
            this.seccionActual++;
          }
        }
        else if(this.seccionActual == 2)
        {
        if(this.SumaPorcentajesSocios() == 100) {
                this.seccionActual++;
              } else{
                this.AlertaEmbajadores("Los socios deben sumar un total de 100% de participacion", true);
                return;
              }
        }
        else {
          if(this.seccionActual != 3){
            this.seccionActual++;
          }
        }
      }
    },
    async ConsultarSolicitudPersonaMoral () {
      const solicitud = {
        params: {
          solicitudId: this.solicitudExistenteId,
        },
      };
    await axios
      .get(rutaConsultarSolicitudPersonaMoral, solicitud)
      .then((resp) => {
        if (resp.data.estado === 0) {
          this.DatosPersonaMoral.solicitudId = resp.data.data.solicitudId;
          this.DatosPersonaMoral.lugarConstitucion = resp.data.data.lugarConstitucion;
          this.DatosPersonaMoral.fechaInicioOperaciones = resp.data.data.fechaInicioOperaciones.substring(0,10);
          this.AjustarNombre(resp.data.data.principalAccionista.split(" "), this.accionista);
          this.AjustarNombre(resp.data.data.representanteLegal.split(" "), this.representanteLegal);
          this.DatosPersonaMoral.giro = resp.data.data.giro;
          this.DatosPersonaMoral.giroId = resp.data.data.giroId;
          this.DatosPersonaMoral.actividadPrincipal = resp.data.data.actividadPrincipal;
          this.DatosPersonaMoral.regimenFiscalId = resp.data.data.regimenFiscalId;
        } else if (resp.data.estado === 1) {
          this.AlertaEmbajadores(resp.data.mensaje, true);
        }
      })
      .catch((e) => {
            this.ManejarExcepcion(e);
      });
    },
    AjustarNombre(arregloNombre, modelo) {
      switch (arregloNombre.length) {
          case 4:
            modelo.nombre = arregloNombre[0] + ' ' + arregloNombre[1];
            modelo.apellidoPaterno = arregloNombre[2];
            modelo.apellidoMaterno = arregloNombre[3];
            break;
          case 3:
            modelo.nombre = arregloNombre[0];
            modelo.apellidoPaterno = arregloNombre[1];
            modelo.apellidoMaterno = arregloNombre[2];
            break;
          case 2:
            modelo.nombre = arregloNombre[0];
            modelo.apellidoPaterno = arregloNombre[1];
            break;
          }
    },
    async CargarDatosProspectoMoral() {
      await axios
        .get(rutaCargarDatosProspecto, prospecto)
        .then((resp) => {
          if (resp.data.estado === 0) {
            this.DatosPersonaMoral.nombreComercial = resp.data.data.nombres;
            this.DatosPersonaMoral.razonSocial =
              resp.data.data.apellidoPaterno;
            this.DatosPersonaMoral.rfc =
              resp.data.data.apellidoMaterno;
            this.PuntoContactoGeneral.correoMoral.valor = resp.data.data.correo;
            this.PuntoContactoGeneral.telefonoFijoOficina.valor = resp.data.data.telefono;
            this.etapaProspecto = resp.data.data.etapaId;
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    ConsultarPuntosContactoMoral() {
      axios.get(rutaConsultarPuntosContacto, prospecto)
      .then((resp) => {
        if (resp.data.estado === 0) {
          let arregloPuntos = resp.data.data;
          for(var punto of arregloPuntos) {
            switch (punto.tipoContacto) {
              case 0:
                this.PuntoContactoGeneral.telefonoFijo.puntoContactoId = punto.puntoContactoId;
                this.PuntoContactoGeneral.telefonoFijo.valor = punto.valor;
                break;
              case 2:
                this.PuntoContactoGeneral.telefonoMovil.puntoContactoId = punto.puntoContactoId;
                this.PuntoContactoGeneral.telefonoMovil.valor = punto.valor;
                break;
              case 1:
                this.PuntoContactoGeneral.telefonoFijoOficina.puntoContactoId = punto.puntoContactoId;
                this.PuntoContactoGeneral.telefonoFijoOficina.valor = punto.valor;
                break;
              case 3:
                this.PuntoContactoGeneral.correoRepresentante.puntoContactoId = punto.puntoContactoId;
                this.PuntoContactoGeneral.correoRepresentante.valor = punto.valor;
                break;
              case 4:
                this.PuntoContactoGeneral.correoMoral.puntoContactoId = punto.puntoContactoId;
                this.PuntoContactoGeneral.correoMoral.valor = punto.valor;
                break;
            }
          }
        }
        }).catch((e) => this.ManejarExcepcion(e));
    },
    ConsultarUbicaciones() {
      axios.get(rutaConsultarUbicaciones, prospecto)
      .then((resp) => {
        if (resp.data.estado === 0) {
          let ubicacion = resp.data.data[0];
          this.DatosUbicacionGeneralOficina.ubicacionId = ubicacion.ubicacionId;
          this.DatosUbicacionGeneralOficina.calle = ubicacion.calle;
          this.DatosUbicacionGeneralOficina.numero = ubicacion.numero;
          this.ConsultarUbicacionLocal(ubicacion.ubicacionId);
        } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, true);
        }
        }).catch((e) => {
             this.ManejarExcepcion(e);
        })
    },
    ConsultarUbicacionLocal(ubicacionId) {
      const ubicacion = {
        params:{
          ubicacionId: ubicacionId
        }
      }
      axios.get(rutaConsultarUbicacionLocal, ubicacion)
      .then((resp) => {
        if (resp.data.estado === 0) {
          this.ConsultarCodigoPostalExistente(resp.data.data.coloniaId);
          this.DatosUbicacionOficina.ubicacionId = resp.data.data.ubicacionId;
          this.DatosUbicacionOficina.coloniaIdOficinaOriginal = resp.data.data.coloniaId;
          this.direccionAuxiliar.coloniaExistente = resp.data.data.coloniaId;
        } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, true);
        }
        }).catch((e) => {
             this.ManejarExcepcion(e);
        })
    },
    ConsultarCodigoPostalExistente(coloniaId) {
      const colonia = {
        params:{
          coloniaId:coloniaId
        }
      }
      axios.get(rutaCodigoPostalExistente, colonia)
      .then((resp) => {
        if (resp.data.estado === 0) {
          this.direccionAuxiliar.codigoPostal = resp.data.data.descripcion;
        }
        }).catch((e) => {
             this.ManejarExcepcion(e);
        })
    },
    ConsultarCodigoPostal(codigoPostal) {
      const parametroCodigo = {
        params:{
          codigoPostal:codigoPostal
        }
      }
      axios.get(rutaCodigosPostales, parametroCodigo)
      .then((resp) => {
        if (resp.data.estado === 0) {
          if(resp.data.data != null){
            this.CargarColonias(resp.data.data.codigoPostalId);
            this.CargarCiudad(resp.data.data.ciudadId);
            this.direccionAuxiliar.codigoPostalValido = true;
          }
        } else if (resp.data.estado === 1) {
            this.catalogos.colonias = [];
            this.direccionAuxiliar.ciudad = "NO DETECTADO";
            this.direccionAuxiliar.estado = "NO DETECTADO";
            this.direccionAuxiliar.codigoPostalValido = false;
        }
        }).catch((e) => {
             this.ManejarExcepcion(e);
        })
    },
    ConsultarSocios() {
      axios.get(rutaConsultarSocios, prospecto)
      .then((resp) => {
        if (resp.data.estado === 0) {
          if(resp.data.data != null){
            let arregloSocios = resp.data.data;
            if(arregloSocios.length > 0) {
              this.FormSocios = [];
              for(var item of arregloSocios) {
                let socio = {
                  socioId: item.socioId,
                  prospectoId: item.prospectoId,
                  nombre: item.nombre,
                  apellidoPaterno: item.apellidoPaterno,
                  apellidoMaterno: item.apellidoMaterno,
                  cargo: item.cargo,
                  participacion: parseFloat(item.participacion)
                };
              this.FormSocios.push(socio);
            }
            }
          }
        }
        }).catch((e) => {
             this.ManejarExcepcion(e);
        })
    },
     ConsultarFiliales() {
      axios.get(rutaConsultarFiliales, prospecto)
      .then((resp) => {
        if (resp.data.estado === 0) {
          if(resp.data.data != null){
            let arregloFiliales = resp.data.data;
            if(arregloFiliales.length > 0) {
              this.FormFiliales = [];
              for(var item of arregloFiliales) {
                let filial = {
                  filialId: item.filialId,
                  prospectoId: item.prospectoId,
                  nombre: item.nombre,
                  ubicacion: item.ubicacion
                };
                this.FormFiliales.push(filial);
              }
            }
          }
        }
        }).catch((e) => {
             this.ManejarExcepcion(e);
        })
    },
    CargarColonias(codigoPostalId) {
      const parametroCodigo = {
        params:{codigoPostalId:codigoPostalId}
      }
      axios.get(rutaColonias, parametroCodigo)
      .then((resp) => {
        if (resp.data.estado === 0) {
            this.catalogos.colonias = resp.data.data;
            //this.DatosUbicacionOficina.coloniaId = this.catalogos.colonias[0].coloniaId;
     if(this.DatosUbicacionOficina.coloniaIdOficinaOriginal) {this.DatosUbicacionOficina.coloniaId = this.DatosUbicacionOficina.coloniaIdOficinaOriginal
                  this.DatosUbicacionOficina.coloniaIdOficinaOriginal = null;}
        }
        }).catch((e) => {
             this.ManejarExcepcion(e);
        })
    },
    CargarCiudad(ciudadId) {
      const parametroCiudad = {
        params: {ciudadId: ciudadId}
      }
      axios.get(rutaCiudad, parametroCiudad)
      .then((resp) => {
        if (resp.data.estado === 0) {
            this.direccionAuxiliar.ciudad = resp.data.data.descripcion;
            this.CargarEstado(resp.data.data.estadoId);
        }
        }).catch((e) => {
             this.ManejarExcepcion(e);
        })
    },
    CargarEstado(estadoId) {
      const parametroEstado = {
        params:{estadoId:estadoId}
      }
      axios.get(rutaEstado, parametroEstado)
      .then((resp) => {
        if (resp.data.estado === 0) {
            this.direccionAuxiliar.estado = resp.data.data.descripcion;
        }
        }).catch((e) => {
             this.ManejarExcepcion(e);
        })
    },
    //FILIALLES
    AgregarFilial() {
      if(this.camposVaciosFilialForm == false){
        const filial = {
          nombre: "",
          ubicacion: ""
        }
        this.FormFiliales.push(filial);
      } else{
        this.AlertaEmbajadores("Por favor rellene todos los campos marcado con un *.",true)
      }

    },
    EliminarFilial(index)  {
      if(this.soloLectura != undefined && this.soloLectura == true) {
        this.AlertaEmbajadores("No se pueden eliminar filiales y/o grupos en el modo solo lectura.",true)
      } else {
          if (this.FormFiliales[index].filialId != 0) {
              //Lo elimina de la base de datos
              const filial = {
              params: {
                  filialId: this.FormFiliales[index].filialId,
              },
              };
              axios
              .delete(rutaEliminarFilial, filial)
              .then((resp) => {
                if (resp.data.estado === 1) {
                  this.AlertaEmbajadores(resp.data.mensaje,true);
                  }
              })
              .catch((e) => {
                  this.ManejarExcepion(e);
              });
              if (index > -1) {
                  this.FormFiliales.splice(index, 1);
              }
          } else {
              if (index > -1) {
                  this.FormFiliales.splice(index, 1);
              }
          }
      }
    },
    //SOCIOS
    LimitarPorcentajeSocios(index){
    //     if(this.FormSocios[index].participacion > 100) {
    //       this.FormSocios[index].participacion = 100;
    //     }
    // },
    this.FormSocios[index].participacion = this.FormSocios[index].participacion != null ? parseFloat(this.FormSocios[index].participacion) : 0;
      if (this.FormSocios.length == 1) {
        if (this.FormSocios[0].participacion > 100) {
          this.FormSocios[0].participacion = 100;
        }
      } else {
        if (this.SumaPorcentajesSocios() > 100) {
          let resta = this.SumaPorcentajesSocios() - this.FormSocios[index].participacion;
          let faltante = 100 - resta;
          this.FormSocios[index].participacion = faltante;
        }
      }
    },
    AgregarSocio() {
      if(this.camposVaciosSocioForm == false){
        this.FormSocios.push(
            {
            nombre: "",
            apellidoPaterno: "",
            apellidoMaterno: "",
            cargo: "",
            participacion: null
          }
        );
      } else {
        this.AlertaEmbajadores("Por favor rellene todos los campos marcados con un *.",true)
      }
    },
    EliminarSocio(index) {
       if(this.soloLectura != undefined && this.soloLectura == true) {
        this.AlertaEmbajadores("No se pueden eliminar socios en el modo solo lectura.",true)
      } else {
        if (this.FormSocios[index].socioId != 0) {
          //Lo elimina de la base de datos
          const socio = {
            params: {
              socioId: this.FormSocios[index].socioId,
            },
          };
          axios
            .delete(rutaEliminarSocio, socio)
            .then((resp) => {
             if (resp.data.estado === 1) {
                this.AlertaEmbajadores(resp.data.mensaje,true);
              }
            })
            .catch((e) => {
             this.ManejarExcepcion(e);
            });

          if (index > -1) {
            this.FormSocios.splice(index, 1);
          }
        } else {
          if (index > -1) {
            this.FormSocios.splice(index, 1);
          }
        }
      }
    },
    //Guardado de datos
    GuardarDatosFormulario() {
      this.AjustarTiposDeDatos();
      this.GuardarSolicitud(this.DatosSolicitudGeneral);
    },
    ActivarEnvioFormulario() {
      this.$refs.submitUltimo.click();
    },
    async GuardarSolicitud(solicitudGeneral, esBorrador){
      this.confirmandoDatos= true;

      let resp = await axios.post(rutaGuardarSolicitud, solicitudGeneral);
      try{
        if (resp.data.estado === 0) {
          this.DatosPersonaMoral.solicitudId = resp.data.data;
          await this.GuardarSolicitudPersonaMoral();
          if(this.solicitudExistenteId != 0) {
           await this.GuardarPuntosDeContacto(false, false);
             this.confirmandoDatos= false;
          } else {
           await this.GuardarPuntosDeContacto(false,true);
             this.confirmandoDatos= false;
          }
         await this.GuardarUbicacionGeneralOficina();
          if(this.FormSocios.length > 0) {
           await this.GuardarSocios();
          }else{
             this.confirmandoDatos= false;
          }
          if(this.FormFiliales.length > 0) {
           await this.GuardarFiliales();
          }else{
             this.confirmandoDatos= false;
          }
          if(this.existeProspectoRepresentanteLegal == false) {
            if((this.representanteLegal.nombre != "" && this.representanteLegal.apellidoPaterno != "") && (this.PuntoContactoGeneral.correoRepresentante.valor != null && this.PuntoContactoGeneral.telefonoMovil.valor != null )) {
              //Validar que los datos existan ya que se estan duplicando registros de representante
              await this.CrearProspectoRepresentanteLegal();
               this.confirmandoDatos= false;
            }
             this.confirmandoDatos= false;
          }

          esBorrador ? this.AlertaEmbajadores("Progreso guardado correctamente", true) : this.AlertaEmbajadores("Solicitud guardada exitosamente.", true);

          if(this.$route.params.vieneDeAdministracion != undefined){
            this.$router.push({name: "IntegracionExpedienteMoral", params: { prospectoId: this.ProspectoId, vieneDeAdministracion: true }});
          } else {
            if(this.tipoUsuario == 6 || this.tipoUsuario == 8 || this.tipoUsuario == 9 || this.tipoUsuario == 10) {
              if(this.etapaProspecto == 4){
                this.$router.push({name: "IntegracionExpedienteMoral"});
              } else {
                this.$router.push({name: "PreAutorizacion"});
              }
            } else {
              if(this.tipoUsuario == 4) {
                this.$router.push({name: "PreAutorizacion"});
              } else {
                this.$router.push({name: "IntegracionExpedienteMoral"});
              }
            }
          }
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje,true);
          }
      }catch(e){
        this.ManejarExcepcion(e);
         this.confirmandoDatos= false;
      }
    },
    async CrearProspectoRepresentanteLegal() {
      await axios.post(rutaCrearProspectoRL + '/?prospectoId=' + parseInt(this.ProspectoId))
        .then(resp => {
          if (resp.data.estado === 0) {
            let pRepresentante = resp.data.data;
            if(pRepresentante != null && pRepresentante.prospectoId > 0)
            {
              this.existeProspectoRepresentanteLegal = true;
            }
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
           this.confirmandoDatos= false
        });
    },
    async GuardarSolicitudPersonaMoral() {
      this.DatosPersonaMoral.principalAccionista = this.accionista.nombre + ' ' + this.accionista.apellidoPaterno + ' ' + this.accionista.apellidoMaterno;
      this.DatosPersonaMoral.representanteLegal = this.representanteLegal.nombre + ' ' + this.representanteLegal.apellidoPaterno + ' ' + this.representanteLegal.apellidoMaterno;

      await axios.post(rutaGuardarSolicitudPm, this.DatosPersonaMoral)
        .then(resp => {
          if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje,true);
          }
        })
        .catch(e => {
             this.ManejarExcepcion(e);
        });
    },
    async GuardarFiliales() {
      for (var filial of this.FormFiliales) {
        if(this.CamposFilialesActualesVacios(this.FormFiliales.indexOf(filial)) == false) {
          filial.prospectoId = this.ProspectoId;
          await axios
            .post(rutaGuardarFilial, filial)
            .then((resp) => {
              if (resp.data.estado === 1) {
                this.AlertaEmbajadores(resp.data.mensaje,true);
              }
            })
            .catch((e) => {
             this.ManejarExcepcion(e);
            });
        }
      }
    },
     CamposSociosActualesVacios(index){
      let llaves = Object.keys(this.FormSocios[index]);
      let vacios = 0;
      llaves.forEach(llave => {
        if(llave != "apellidoMaterno" && llave != "socioId" && llave != "prospectoId"){
          if(this.FormSocios[index][llave] == "" || this.FormSocios[index][llave] == null){
            vacios++;
          }
        }
      });
      return vacios > 0 ? true : false;
    },
     CamposFilialesActualesVacios(index){
      let llaves = Object.keys(this.FormFiliales[index]);
      let vacios = 0;
      llaves.forEach(llave => {
        if(llave != "filialId" && llave != "prospectoId"){
          if(this.FormFiliales[index][llave] == "" || this.FormFiliales[index][llave] == null){
            vacios++;
          }
        }
      });
      return vacios > 0 ? true : false;
    },
    async GuardarSocios() {
      for (var socio of this.FormSocios) {
        if(this.CamposSociosActualesVacios(this.FormSocios.indexOf(socio)) == false) {
          socio.prospectoId = this.ProspectoId;
         await axios
            .post(rutaGuardarSocio, socio)
            .then((resp) => {
              if (resp.data.estado === 1) {
                this.AlertaEmbajadores(resp.data.mensaje,true);
              }
            })
            .catch((e) => {
             this.ManejarExcepcion(e);
            });
        }
      }
    },
    async GuardarUbicacionGeneralOficina() {
     await axios.post(rutaGuardarUbicacion,this.DatosUbicacionGeneralOficina)
        .then(resp => {
          if (resp.data.estado === 0) {
            let ubicacionId = resp.data.data;
            this.DatosUbicacionOficina.ubicacionId = ubicacionId;
            this.GuardarUbicacionOficina(this.DatosUbicacionOficina);
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje,true);
          }
        })
        .catch(e => {
             this.ManejarExcepcion(e);
        });
    },
    async GuardarUbicacionOficina(ubicacionOficina) {
      await axios.post(rutaGuardarUbicacionLocal, ubicacionOficina)
        .then(resp => {
          if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje,true);
          }
        })
        .catch(e => {
             this.ManejarExcepcion(e);
        });
    },
    //Ajustes tipos de datos
    AjustarTiposDeDatos() {
        this.DatosSolicitudGeneral.producto = this.DatosSolicitudGeneral.producto != null ? parseInt(this.DatosSolicitudGeneral.producto) : null;
      this.DatosSolicitudGeneral.servicio = this.DatosSolicitudGeneral.servicio != null ? parseInt(this.DatosSolicitudGeneral.servicio) : null;
      this.DatosSolicitudGeneral.envioEstadoCuenta = this.DatosSolicitudGeneral.envioEstadoCuenta != null ? parseInt(this.DatosSolicitudGeneral.envioEstadoCuenta) : null;
      this.DatosSolicitudGeneral.enCasoAutorizacion = this.DatosSolicitudGeneral.enCasoAutorizacion != null ? parseInt(this.DatosSolicitudGeneral.enCasoAutorizacion) : null;
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../../../../assets/estilos/estilosgenerales.scss";

.form-group {
  margin-bottom: -15px;
}
input[type="number"] {
  -moz-appearance: textfield;
  appearance: texfield;
}

.texto-politicas {
  font-family: $poppins;
  font-size: 14px;
  color: #000000;
}

.li-progress-moral {
  width: 32% !important;
  font-size: 14px;
}
</style>
